export const TRAFFIC_SOURCES: {
  GOOGLE: ITrafficSource;
  GOOGLE_MERCHANT: ITrafficSource;
  FACEBOOK: ITrafficSource;
  TIKTOK: ITrafficSource;
  PINTEREST: ITrafficSource;
  MICROSOFT: ITrafficSource;
  SNAPCHAT: ITrafficSource;
  TWITTER: ITrafficSource;
  CHATGPT: ITrafficSource;
  EMAIL: ITrafficSource;
} = {
  GOOGLE: { id: 'gclid', name: 'Google', label: 'Google Ads' },
  GOOGLE_MERCHANT: { id: 'srsltid', name: 'Google Merchant', label: 'Organic - Google Merchant' },
  FACEBOOK: { id: 'fbclid', name: 'Facebook', label: 'Facebook Ads' },
  TIKTOK: { id: 'ttclid', name: 'TikTok', label: 'TikTok Ads' },
  PINTEREST: { id: 'pclid', name: 'Pinterest', label: 'Pinterest Ads' },
  MICROSOFT: { id: 'msclid', name: 'Microsoft', label: 'Microsoft Ads' },
  SNAPCHAT: { id: 'scid', name: 'Snapchat', label: 'Snapchat Ads' },
  TWITTER: { id: 'twclid', name: 'Twitter', label: 'Twitter Ads' },
  CHATGPT: { id: 'utm_source', name: 'ChatGPT', label: 'ChatGPT Ads' },
  EMAIL: { id: 'utm_source', name: 'Email', label: 'Email' }
};

export interface ITrafficSource {
  name: string;
  id: string;
  label: string;
}
